/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = "eac95e456efe6c1aa182";
/******/
/******/ 	// __webpack_chunkname__
/******/ 	__webpack_require__.cn = "rescue";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./resources/assets/javascript/rescue.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/whatwg-fetch/fetch.js":
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ "./resources/assets/javascript/rescue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./node_modules/whatwg-fetch/fetch.js");

try {
    if (window.localStorage) {
        window.__rescueErrors = JSON.parse(localStorage.getItem('__rescueErrors') || '[]');

        var storedLogs = JSON.parse(localStorage.getItem('__rescueLogs') || '[]');
        window.__rescueLogs = (Array.isArray(storedLogs) ? storedLogs : []).slice(-10);

        try {
            localStorage.setItem('__rescueLogs', JSON.stringify(window.__rescueLogs));
        } catch (exSet) {
            window.Sentry && window.Sentry.captureException(exSet);
        }
    } else {
        window.__rescueErrors = [];
        window.__rescueLogs = [];
    }
} catch (ex) {
    window.Sentry && window.Sentry.captureException(ex);
    window.__rescueErrors = [];
    window.__rescueLogs = [];
}

var isEntryLoggable = function isEntryLoggable(obj) {
    try {
        JSON.stringify(obj);
        return true;
    } catch (err) {
        return false;
    }
};

// Se não tiver em desenvolvimento salva os logs em localStorage para consultas futuras
if (true) {
    var _loop = function _loop(level) {
        var realLog = console[level];

        console[level] = function () {
            var args = Array.prototype.slice.call(arguments);

            var isErrorEntry = level === 'error' || args.some(function (a) {
                return a instanceof Error;
            });

            if (isErrorEntry && isEntryLoggable(args)) {
                window.__rescueLogs.push({ level: level, args: args, url: location.href, online: navigator.onLine });
                window.__rescueLogs = window.__rescueLogs.slice(-10);

                if (window.localStorage) {
                    var persistLogs = function persistLogs(logs) {
                        try {
                            localStorage.setItem('__rescueLogs', JSON.stringify(logs));
                        } catch (ex) {
                            if (logs.length > 0) {
                                persistLogs(logs.slice(1));
                            } else {
                                try {
                                    localStorage.removeItem('__rescueLogs');
                                } catch (ex2) {
                                    window.Sentry && window.Sentry.captureException(ex2);
                                }
                            }
                        }
                    };

                    persistLogs(window.__rescueLogs);
                }
            }

            if (false) {
                realLog.apply(console, arguments);
            }
        };
    };

    var _arr = ['log', 'info', 'error', 'warn', 'trace'];

    for (var _i = 0; _i < _arr.length; _i++) {
        var level = _arr[_i];
        _loop(level);
    }
}

// O Rescue cuidará de escutar erros e reporta-los.

var reportMessage = function reportMessage(message) {
    var data = {
        message: message,
        data: JSON.stringify({
            instanceCode: window.__instanceCode,
            userId: window.__userId,
            url: location.href,
            adblockEnabled: window.__userIsUsingAdblockOrRelated,
            version: window.__version,
            buildName: window.__name,
            slugName: window.__slugname,
            navigator: {
                online: navigator.onLine,
                appCodeName: navigator.appCodeName,
                appName: navigator.appName,
                appVersion: navigator.appVersion,
                cookieEnabled: navigator.cookieEnabled,
                hardwareConcurrency: navigator.hardwareConcurrency,
                language: navigator.language,
                platform: navigator.platform,
                product: navigator.product,
                productSub: navigator.productSub,
                userAgent: navigator.userAgent,
                vendor: navigator.vendor,
                vendorSub: navigator.vendorSub
            },
            token: window.__sessionToken
        }),
        when: new Date(),
        source: 'sci-online-frontend'
    };

    if (true) {
        // fetch('//microsistec-rescue.appspot.com/api/messages', {
        //     'method': 'post',
        //     'headers': {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json'
        //     },
        //     'body': JSON.stringify(data)
        // }).catch((ex) => {
        //     console.log(ex)
        // })
    } else {
        console.log({ errorInfo: data });
    }
};

var report = function report(error, message, stack) {
    var token = null;

    var tokenEl = document.getElementById('user-token');
    if (tokenEl) {
        token = tokenEl.value;
    }

    var data = {
        message: message,
        data: JSON.stringify({
            stack: stack,
            instanceCode: window.__instanceCode,
            userId: window.__userId,
            url: location.href,
            adblockEnabled: window.__userIsUsingAdblockOrRelated,
            version: window.__version,
            buildName: window.__name,
            slugName: window.__slugname,
            navigator: {
                online: navigator.onLine,
                appCodeName: navigator.appCodeName,
                appName: navigator.appName,
                appVersion: navigator.appVersion,
                cookieEnabled: navigator.cookieEnabled,
                hardwareConcurrency: navigator.hardwareConcurrency,
                language: navigator.language,
                platform: navigator.platform,
                product: navigator.product,
                productSub: navigator.productSub,
                userAgent: navigator.userAgent,
                vendor: navigator.vendor,
                vendorSub: navigator.vendorSub
            },
            token: window.__sessionToken
        }),
        file: error.filename || 'none',
        when: new Date(),
        source: 'sci-online-frontend'
    };

    var reported = { info: data, error: [error] };

    window.dispatchEvent(new CustomEvent('rescue:error', {
        'detail': reported
    }));

    window.__rescueErrors.push(data);

    if (window.localStorage) {
        localStorage.setItem('__rescueErrors', JSON.stringify(window.__rescueErrors.slice(-50)));
    }

    if (!error.skip) {
        if (true) {}
        // fetch('//microsistec-rescue.appspot.com/api/messages', {
        //     'method': 'post',
        //     'headers': {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json'
        //     },
        //     'body': JSON.stringify(data)
        // }).catch((ex) => {
        //     console.log(ex)
        // })


        //         let errorModal = document.getElementsByClassName('fatal-error-modal')[0];
        //
        //         if (IS_DEV && document.body && !error.isHidden && !errorModal) {
        //             let node = document.createElement('div');
        //             node.innerHTML = `
        // <div style="position: fixed; background-color: #ff8c6f; top: 0; bottom: 0; left: 0; right: 0; z-index: 9999999999999" class="fatal-error-modal">
        //     <a href="javascript:;" class="fatal-error-close-button" style="color: white; font-weight: bold; font-size: 50px; position: absolute; right: 15px; top: 15px; line-height: 28px; text-decoration: none">
        //         &times;
        //     </a>
        //     <div style="margin: 0 auto; width: 80%">
        //         <h3 style="color: white; font-weight: bold; font-family: sans-serif; font-size: 25px; text-shadow: 1px 1px 0px rgba(0,0,0,.3)">
        //             Oooops... Aconteceu um erro fatal que provavelmente impedirá você de usufruir do nosso serviço, esse erro já foi enviado para nossos desenvolvedores e em breve será solucionado! Você pode tentar recarregar a página e tentar novamente enquanto isso.
        //         </h3>
        //         <div style="margin-top: 50px; text-align: left">
        //             <button class="fatal-error-home-button" style="color: black; font-size: 16px; padding: 4px 10px; border-radius: 3px; background-color: white; border: none; margin-right: 6px">página inicial</button>
        //             <button class="fatal-error-reload-button" style="color: black; font-size: 16px; padding: 4px 10px; border-radius: 3px; background-color: white; border: none;">atualizar página</button>
        //         </div>
        //     </div>
        // </div>
        // `;
        //             let closeButton = node.getElementsByClassName('fatal-error-close-button')[0];
        //             let reloadButton = node.getElementsByClassName('fatal-error-reload-button')[0];
        //             let homeButton = node.getElementsByClassName('fatal-error-home-button')[0];
        //             closeButton.addEventListener('click', (event) => {
        //                 document.body.removeChild(node);
        //             });
        //             homeButton.addEventListener('click', (event) => {
        //                 location.href = '/';
        //             });
        //             reloadButton.addEventListener('click', (event) => {
        //                 location.href = location.href;
        //             });
        //             document.body.appendChild(node)
        //         }
    }
};

// window.onerror = function (message, file, line, col, error) {
//     // TODO: isso
//
//     return false
// }
//
// window.addEventListener('error', function (event, a, b) {
//     if (event.error) {
//         report(event.error, event.error.message, event.error.stack)
//     } else {
//         report(event, event.message, event.stack)
//     }
//
//     return false
// })
//
// window.addEventListener('unhandledrejection', function (event, a, b) {
//     let reason = null
//     if (event.detail) {
//         reason = event.detail.reason
//     } else {
//         reason = event.reason
//     }
//
//     report(reason, reason.message, reason.stack)
// })

window.rescue = {
    error: function error(message) {
        if (false) {
            console.error(message);
        }
        reportMessage(message);
    }
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// rescue.min.js